import React from "react";
import { DataSourceType } from "./types";
import { getFileIcon } from "./utils";

interface DataSourceDetailProps {
  dataSource: DataSourceType;
  downloadingFile: string | null;
  onDownloadFile: (filePath: string, fileName: string) => void;
  attachmentsLabel: string;
  /** Optional header content to render at the top */
  headerContent?: React.ReactNode;
  /** Optional actions content to render next to back button */
  actionsContent?: React.ReactNode;
  /** Container className for custom styling */
  containerClassName?: string;
  /** Content wrapper className for custom styling */
  contentClassName?: string;
}

const DataSourceDetail: React.FC<DataSourceDetailProps> = ({
  dataSource,
  downloadingFile,
  onDownloadFile,
  attachmentsLabel,
  headerContent,
  actionsContent,
  containerClassName = "",
  contentClassName = "w-full py-4",
}) => {
  return (
    <div className={`${containerClassName} flex flex-col overflow-hidden`}>
      {headerContent}
      <div className={`${contentClassName} flex-1 overflow-y-auto min-h-0`}>
        {actionsContent && (
          <div className="mb-6 flex justify-between items-center">
            {actionsContent}
          </div>
        )}

        <div className="mb-6">
          <h1 className="text-4xl font-bold text-[#00463B] mb-3">
            {dataSource.title}
          </h1>
          <div className="mb-4">
            <span className="text-[#777] text-base">{dataSource.version}</span>
          </div>
          <p className="text-[#333] leading-relaxed whitespace-pre-wrap">
            {dataSource.content}
          </p>
        </div>

        {dataSource.files && dataSource.files.length > 0 && (
          <div className="mb-6">
            <h2 className="text-lg font-bold text-[#00463B] mb-4">
              {attachmentsLabel}
            </h2>
            <div className="flex flex-col gap-2">
              {dataSource.files.map((file) => (
                <div
                  key={file.id}
                  className={`flex items-center cursor-pointer hover:opacity-80 transition-opacity ${downloadingFile === file.url ? "opacity-50" : ""
                    }`}
                  onClick={() => {
                    if (file.url && !downloadingFile) {
                      onDownloadFile(file.url, file.name);
                    }
                  }}
                  role="button"
                  tabIndex={0}
                >
                  <span className="material-icons text-[20px] text-[#00463B] mr-2">
                    {downloadingFile === file.url
                      ? "hourglass_empty"
                      : getFileIcon(file.type)}
                  </span>
                  <span className="text-[#007934] hover:underline">
                    {file.name}
                  </span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default DataSourceDetail;
